import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { PanelMenu } from 'primereact/panelmenu';
import { useNavigate, useLocation } from "react-router-dom";
import 'primeicons/primeicons.css';

function SidebarMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useContext(AuthContext);

  const logOut = () => {
    logout();
    navigate('/login');
  };

  // Kullanıcı rolü: admin, manager, employee vs.
  const role = user?.role || '';

  const isAdmin = role === 'admin';
  const isManager = role === 'manager';

  const createTemplate = (path) => (item, options) => {
    if (location.pathname === path) {
      options.className += ' active-menu-item';
    }
    return options.element;
  };

  const createItem = (label, icon, path) => ({
    label,
    icon,
    command: () => navigate(path),
    template: createTemplate(path)
  });

  // Menü öğeleri
  const baseItems = [
    createItem('Dashboard', 'pi pi-fw pi-home', '/'),
    createItem('Çalışanlar', 'pi pi-fw pi-home', '/employees'),
    {
      label: 'Talep Yönetimi',
      icon: 'pi pi-fw pi-users',
      items: [
        createItem('İzin Talebi', 'pi pi-fw pi-list', '/leaves'),
        createItem('Harcama Talebi', 'pi pi-fw pi-user-plus', '/expenses')
      ]
    },
  ];

  const adminItem = createItem('Admin', 'pi pi-fw pi-cog', '/admin');

  const managerItem = createItem('Management', 'pi pi-fw pi-cog', '/management');

  const candidateItem = createItem('Adaylar', 'pi pi-fw pi-cog', '/candidates');


  const logoutItem = {
    label: 'Çıkış',
    icon: 'pi pi-fw pi-sign-out',
    command: () => logOut()
  };

  // Rol bazlı filtreleme
  if (isAdmin) {
    baseItems.push(adminItem, managerItem,candidateItem);
  } else if (isManager) {
    baseItems.push(managerItem);
  }

  baseItems.push(logoutItem);

  return (
    <aside className="sidebar">
      <div className="logo">
        <h2>HR Plus</h2>
      </div>
      <PanelMenu model={baseItems} className="menu" />
    </aside>
  );
}

export default SidebarMenu;
